export default {
  status: {
    pending: 'In attesa del DNS',
    verified: 'Online',
    failed: 'Intervento necessario',
  },
  summary: {
    preparing:
      'I record per {{host}} sono in preparazione. Compaiono qui entro circa 15 minuti — o subito dopo aver premuto Verifica di nuovo.',
    pending:
      'In attesa dei record DNS qui sotto. Di solito servono pochi minuti, ma possono volerci fino a 48 ore — continuiamo a controllare in automatico.',
    certificate_pending:
      'I record sono a posto. Il certificato per {{host}} è in fase di emissione — di solito ci vogliono pochi minuti.',
    verified: 'Il negozio online è attivo su {{host}}.',
    serving: 'Il negozio online è attivo su {{serving_host}}, ma {{host}} stesso non lo apre ancora.',
    apex_elsewhere:
      "Il record A su @ non punta ancora al negozio. Se {{host}} mostra un sito web che deve restare lì, lascia @ com'è — il negozio funziona su {{serving_host}}. Altrimenti aggiungi il record A qui sotto.",
    apex_held:
      '{{host}} è usato da un altro sito web su Vercel. Perché anche {{host}} apra il negozio, rimuovi prima il dominio da quel sito web.',
    regressed:
      '{{host}} funzionava, ma un record qui sotto non risulta più corretto. Correggilo presso il provider DNS, poi premi Verifica di nuovo.',
    record_elsewhere:
      'Un record qui sotto punta altrove. Modificalo presso il provider DNS con il valore indicato, poi premi Verifica di nuovo.',
    records_missing:
      'I record qui sotto non vengono ancora trovati dopo 48 ore. Controlla che siano stati salvati per {{zone}}, presso il provider che ne gestisce il DNS. Se quel provider non consente la modifica, il dominio potrebbe essere bloccato lì.',
    certificate: {
      ownership_proof_required:
        '{{host}} è collegato anche a un altro account Vercel, quindi il ristorante deve dimostrare che il dominio è suo.',
      held_by_another_project:
        '{{host}} è ancora usato da un altro sito web su Vercel, quindi il negozio non può ancora usarlo.',
      dns_correct_but_unconfigured: "I record sono corretti, ma qualcos'altro su {{host}} blocca il certificato.",
      name_mismatch: '{{host}} risponde ancora con un certificato per un altro nome.',
      expired: 'Il certificato per {{host}} è scaduto. Abbiamo ricevuto la segnalazione e ce ne stiamo occupando.',
      expiring: 'Il certificato per {{host}} scade a breve e non è ancora stato rinnovato. Ce ne stiamo occupando.',
      attach_refused:
        'Il nostro provider di hosting ha rifiutato di aggiungere {{host}} dalla nostra parte. Siamo stati avvisati e ce ne stiamo occupando.',
      overdue: 'Il certificato per {{host}} non è ancora stato emesso dopo 48 ore.',
      unknown: 'Non è stato possibile emettere il certificato per {{host}}.',
    },
    certificate_see_row: 'La riga del certificato qui sotto indica cosa fare.',
  },
  instructions: {
    title: 'Come collegare {{host}}',
    step_provider:
      "Accedi dove viene gestito il DNS di {{zone}} — di solito l'azienda presso cui è stato acquistato il dominio.",
    step_add: 'Aggiungi ogni record qui sotto esattamente come indicato: tipo, nome e valore.',
    step_check: 'Salva, poi premi {{button}}. Continuiamo anche a controllare in automatico.',
    tip_name:
      'La maggior parte dei provider vuole solo la parte prima di {{zone}} nel campo del nome — qui {{names}}. È indicato anche il nome completo, per i provider che lo richiedono.',
    tip_apex: '@ indica {{zone}} stesso. Alcuni provider lasciano invece il nome vuoto.',
    tip_apex_website:
      'Se {{zone}} apre già un sito web, puntare @ al negozio toglie {{zone}} a quel sito. Per mantenere lì il sito web, lascia i record su @ come sono — il negozio funziona comunque su www.{{zone}} — oppure collega invece un sottodominio come order.{{zone}} per il negozio.',
    tip_existing:
      'Rimuovi qualsiasi altro record A, AAAA o CNAME su {{name}}. Due record che puntano a destinazioni diverse fanno caricare il negozio solo a volte.',
    tip_cloudflare:
      'Su Cloudflare, imposta questi record su Solo DNS (nuvola grigia). Con il proxy attivo nessuno può vedere dove puntano e non è possibile emettere alcun certificato.',
    tip_locked:
      'Se il provider non consente di aggiungere o modificare questi record, il dominio potrebbe essere bloccato oppure il suo DNS è gestito altrove. Il provider può sbloccarlo o indicare dove viene gestito il DNS.',
  },
  records: {
    title: 'Record per {{host}}',
  },
  separate_domains: {
    apex: 'Questo dominio è solo per il negozio online: il negozio occupa {{zone}} e www.{{zone}}. Un sito web ha bisogno di un altro nome — un sottodominio di {{zone}} o un dominio proprio.',
    subdomain: 'Questo dominio è solo per il negozio online. Un sito web può usare {{zone}} o www.{{zone}}.',
  },
  load_error: 'Impossibile caricare lo stato del dominio.',
  no_access: 'Nessun accesso allo stato del dominio di questo ristorante.',
  polling_stopped: 'Questa pagina ha smesso di aggiornarsi da sola. Premi Verifica di nuovo per aggiornarla.',
  buttons: {
    check_again: 'Verifica di nuovo',
    retry: 'Riprova',
  },
  toasts: {
    check_started: 'Verifica dei record in corso. Può richiedere un minuto.',
    check_failed: 'Impossibile avviare la verifica. Riprova.',
    check_too_soon: 'Appena verificato. Attendi un minuto prima di verificare di nuovo.',
  },
};
